/**
 * Locations Service Hooks
 * React hooks for accessing location management services
 */
import { useCCMS } from '../useCCMS';
/**
 * Hook to access all location-related services
 * @returns LocationsServices object containing all location service instances
 */
export function useLocationsServices() {
    const { services } = useCCMS();
    if (!services?.locations) {
        throw new Error('Locations services not available. Ensure CCMSProvider is configured with locations services.');
    }
    return services.locations;
}
/**
 * Hook to access LocationService
 */
export function useLocationService() {
    return useLocationsServices().location;
}
/**
 * Hook to access AddressService
 */
export function useAddressService() {
    return useLocationsServices().address;
}
/**
 * Hook to access LocationInfoService
 */
export function useLocationInfoService() {
    return useLocationsServices().locationInfo;
}
/**
 * Hook to access LocationLeaderService
 */
export function useLocationLeaderService() {
    return useLocationsServices().locationLeader;
}
/**
 * Hook to access LocationSocialMediaService
 */
export function useLocationSocialMediaService() {
    return useLocationsServices().locationSocialMedia;
}
/**
 * Hook to access LocationVenueService
 */
export function useLocationVenueService() {
    return useLocationsServices().locationVenue;
}
/**
 * Hook to access ServiceTimeService
 */
export function useServiceTimeService() {
    return useLocationsServices().serviceTime;
}
/**
 * Hook to access SocialMediaService
 */
export function useSocialMediaService() {
    return useLocationsServices().socialMedia;
}
//# sourceMappingURL=useLocationsServices.js.map